import { PolicyChangeAction } from 'core/helpers/policy-status';
import { localToUtcTime } from '../dates';

export const getScreenAction = ({
  cancel,
  fullTermCancel,
  transactionDate,
  storedEndDate,
  fullTermPolicyEndDate,
  state
}) => {
  const endDateShortened =
    localToUtcTime(`${storedEndDate}T23:59:59.99`, state) <
    localToUtcTime(`${fullTermPolicyEndDate}T23:59:59.99`, state);
  if (cancel || fullTermCancel || transactionDate || endDateShortened) {
    return PolicyChangeAction.Cancel;
  }
  return undefined;
};

export const POLICY_CHANGE_ACTION_FOOTER_LABEL = {
  [PolicyChangeAction.Reinstate]: 'Reinstate Policy',
  [PolicyChangeAction.Rescind]: 'Rescind Cancellation',
  [PolicyChangeAction.Cancel]: 'Cancel Policy'
};
